// ── Map overlay transition constants ──────────────────────────────────────────
// Used by WindStreamletLayer and other ambient overlays (J-09, ADR-023).
// Values chosen per RULE-154 timing harmonization analysis:
//   flyTo duration: 800ms
//   MapLibre idle event lag: 50–300ms after moveend
//   Overlay fade starts AFTER idle, so total wait = 800ms + 50–300ms + 180ms = ~1050–1100ms

/** Fade-in duration (ms) for ambient map overlays after map reaches idle state. */
export const MAP_OVERLAY_FADE_IN_MS = 180;

/** Fade-out duration (ms) for ambient map overlays when map starts moving. 0 = immediate hide. */
export const MAP_OVERLAY_FADE_OUT_MS = 0;

/**
 * Debounce duration (ms) between moveend and starting the idle check.
 * Set to 0 to rely entirely on MapLibre's idle event (which fires after tiles load).
 */
export const MAP_OVERLAY_IDLE_DEBOUNCE_MS = 0;
